import { render, staticRenderFns } from "./curSale-warehouse-discard-detail.vue?vue&type=template&id=ab6853c2&scoped=true"
import script from "./curSale-warehouse-discard-detail.vue?vue&type=script&lang=js"
export * from "./curSale-warehouse-discard-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6853c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab6853c2')) {
      api.createRecord('ab6853c2', component.options)
    } else {
      api.reload('ab6853c2', component.options)
    }
    module.hot.accept("./curSale-warehouse-discard-detail.vue?vue&type=template&id=ab6853c2&scoped=true", function () {
      api.rerender('ab6853c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/warehouse-management/curSale-warehouse-store/curSale-warehouse-discard-detail.vue"
export default component.exports